import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sigv-login-header',
  templateUrl: './login-header.component.html',
  styleUrls: ['./login-header.component.scss'],
})
export class LoginHeaderComponent implements OnInit {

  isVisible = true;

  constructor() {}

  ngOnInit(): void {}
}
